/**
 * KindBadge — MCP/API uppercase pill. Verbatim: height 20, pad 0 8, radius
 * full, tone-soft/line, fs 10, semibold, letter-spacing 0.03em, uppercase.
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { fontFamily, fontWeight, radii } from '../theme';

type Props = { label: string; tone: string };

export default function KindBadge({ label, tone }: Props) {
  return (
    <View style={[styles.badge, { borderColor: `var(--${tone}-line)`, backgroundColor: `var(--${tone}-soft)` } as any]}>
      <Text style={[styles.text, { color: `var(--${tone})` } as any]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    height: 20,
    paddingHorizontal: 8,
    borderRadius: radii.full,
    borderWidth: 1,
  },
  text: {
    fontFamily: fontFamily.sans,
    fontSize: 10,
    fontWeight: fontWeight.semibold,
    letterSpacing: 0.3,
    textTransform: 'uppercase',
  },
});
